/**
 * @license
 * Copyright 2026 Kai-Orion & Sandlada
 * SPDX-License-Identifier: MIT
 *
 * @fileoverview
 * Public navigation utility exports.
 *
 * @example
 * ```ts
 * import { GlobalNavigationStateStore } from '@sandlada/mdc/utils'
 *
 * GlobalNavigationStateStore.setActive('main-nav', '/settings')
 * ```
 */
export * from './navigation-state-store'
